import { useEffect, useState } from "react"
import { InteressedItem } from "../InteressedItem";
import { InteressedContent } from "./styles";

interface Interest{
    id: number,
    name: string,
    icon: string
}

export function InteressedStack(){
    const [interessedStacks, setInteressedStacks] = useState<Interest[]>([]);

    useEffect(()=>{
        fetch('./services/interessed.json',{
            headers:{
                Accept:"application/json"
            }
        }).then(response => response.json())
        .then(data => setInteressedStacks(data.interessed))
    },[]);

    return(
        <InteressedContent>
            <h3>Tenho Interesse</h3>
            <ul>
                {interessedStacks.map(interessedStack =>{
                    return (<InteressedItem key={interessedStack.id} InterestItem={interessedStack} />)
                })}
            </ul>
        </InteressedContent>
    )
}